/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  'use strict';

  var FORM_SUCCESS_EVENT_NAME = 'lynktr:form_submit_success';
  var PENDING_FORM_KEY = 'lynktr:form-submit-success:pending:v1';
  var DELIVERY_KEY_PREFIX = 'lynktr:form-submit-success:delivery:';
  var path = window.location.pathname.replace(/\/$/, '') || '/';
  var isReferenceHome = path === '/' && Boolean(document.querySelector('.lynktr-reference-home-section'));
  var ROUTE_VERSION = isReferenceHome ? '2026-10-31-home-reference-v1' : path === '/pages/contact-us'
    ? '2026-09-16-contact-survey-page-v6'
    : (path === '/' ? '2026-09-16-homepage-survey-page-v6' : '2026-09-16-survey-page-v3');
  var CONTACT_SURVEY_LABEL = 'Request a Site Survey';
  var routeId = isReferenceHome ? 'homepage-reference' : path === '/' ? 'homepage-site-survey' :
    (path === '/pages/contact-us' ? 'contact-site-survey' : 'global-site-survey');
  var trackedSelector = [
    'a[href*="/pages/contact-us"]',
    'a[href*="/pages/request-a-site-survey"]',
    'a[href*="wa.me/"]',
    'a[href*="lynktr-homepage-survey"]',
    '.lynktr-homepage__survey-form button[type="submit"]',
    'form.lynktr-cro-form#contact_form button[type="submit"]'
  ].join(',');

  document.documentElement.setAttribute('data-lynktr-route-id', routeId);
  document.documentElement.setAttribute('data-lynktr-route-version', ROUTE_VERSION);

  function normaliseContactSurveyLabels() {
    if (path !== '/pages/contact-us') return;

    var priorPrimaryLabels = [
      'request free site survey',
      'book free site survey',
      'book a site survey',
      'book your free site survey',
      'send my site-survey request',
      'request a site survey'
    ];

    document.querySelectorAll('a, button').forEach(function (element) {
      var label = (element.textContent || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      if (priorPrimaryLabels.indexOf(label) === -1) return;
      element.textContent = CONTACT_SURVEY_LABEL;
      if (element.hasAttribute('aria-label')) {
        element.setAttribute('aria-label', CONTACT_SURVEY_LABEL);
      }
    });
  }

  function slug(value) {
    return (value || 'action')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 48) || 'action';
  }

  function placement(element) {
    if (element.closest('.mobile-menu, [class*="mobile-menu"]')) return 'mobile-menu';
    if (element.closest('.lynktr-homepage--hero-module, [id*="lynktr-home-hero"]')) return 'home-hero';
    if (element.closest('.lynktr-homepage--spaces-module, [id*="lynktr-home-spaces"]')) return 'home-spaces';
    if (element.closest('.lynktr-homepage--contact-module, [id*="lynktr-home-contact"]')) return 'home-contact';
    if (element.closest('.lynktr-cro-contact, form.lynktr-cro-form')) return 'contact-page';
    if (element.closest('header, .lynktr-header, [id*="lynktr-header"]')) return 'global-header';
    if (element.closest('footer, .lynktr-footer, [id*="lynktr-footer"]')) return 'global-footer';
    if (element.closest('.lynktr-floating-chat')) return 'floating-whatsapp';
    return slug(path === '/' ? 'homepage' : path);
  }

  function intentFor(element) {
    if (isReferenceHome && element.closest('.nd-page') && element.getAttribute('data-home-intent')) return element.getAttribute('data-home-intent');
    var href = element.getAttribute('href') || '';
    var rawLabel = (element.textContent || element.getAttribute('aria-label') || '').toLowerCase();
    var label = slug(rawLabel);

    if (href.indexOf('wa.me/') !== -1) return 'whatsapp-enquiry';
    if (rawLabel.indexOf('request quote') !== -1) return 'quote-request';
    if (rawLabel.indexOf('check availability') !== -1) return 'availability-check';
    if (rawLabel.indexOf('ask expert') !== -1 || rawLabel.indexOf('ask our expert') !== -1) return 'expert-enquiry';
    if (rawLabel.indexOf('site survey') !== -1) return 'site-survey-request';
    if (element.matches('button[type="submit"]')) return 'site-survey-request';
    if (href.indexOf('lynktr-homepage-survey') !== -1) return 'site-survey-request';
    return label;
  }

  function contextFor(element, ctaId) {
    if (isReferenceHome && element.closest('.nd-page') && element.getAttribute('data-home-cta-id')) ctaId = element.getAttribute('data-home-cta-id');
    var locationContext = contextFromLocation();
    return {
      cta_id: ctaId,
      route_id: routeId,
      route_version: ROUTE_VERSION,
      intent: intentFor(element),
      source_path: path,
      utm_source: locationContext.utm_source,
      utm_medium: locationContext.utm_medium,
      utm_campaign: locationContext.utm_campaign,
      utm_content: locationContext.utm_content
    };
  }

  function ensureHidden(form, name, value) {
    var field = form.querySelector('input[name="' + name + '"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = value || '';
  }

  function surveyForms() {
    return document.querySelectorAll('.lynktr-homepage__survey-form, form.lynktr-cro-form#contact_form');
  }

  function formDisplayForIntent(intent) {
    if (intent === 'quote-request') {
      return {
        heading: 'Request a Quote',
        note: 'Share your location and requirement. We’ll review it and contact you about the appropriate next step.',
        label: 'Request Quote'
      };
    }

    if (intent === 'availability-check') {
      return {
        heading: 'Check Availability',
        note: 'Tell us what product or system you’re considering and your location. We’ll check the appropriate next step.',
        label: 'Check Availability'
      };
    }

    if (intent === 'expert-enquiry') {
      return {
        heading: 'Ask an Expert',
        note: 'Share your location and requirement. We’ll review it and contact you about the appropriate next step.',
        label: 'Send Enquiry'
      };
    }

    return null;
  }

  function updateFormDisplay(form, context) {
    var module = form.closest('.lynktr-homepage__form');
    if (!module) return;

    var heading = module.querySelector('[data-default-heading]');
    var note = module.querySelector('[data-default-note]');
    var submit = form.querySelector('[data-default-label]');
    var display = formDisplayForIntent(context.intent);

    if (heading) heading.textContent = display ? display.heading : heading.getAttribute('data-default-heading');
    if (note) note.textContent = display ? display.note : note.getAttribute('data-default-note');
    if (submit) submit.textContent = display ? display.label : submit.getAttribute('data-default-label');
  }

  function applyContextToForms(context) {
    surveyForms().forEach(function (form) {
      ensureHidden(form, 'contact[route_id]', context.route_id);
      ensureHidden(form, 'contact[route_version]', context.route_version);
      ensureHidden(form, 'contact[intent]', context.intent);
      ensureHidden(form, 'contact[cta_id]', context.cta_id);
      ensureHidden(form, 'contact[source_path]', context.source_path);
      ensureHidden(form, 'contact[utm_source]', context.utm_source);
      ensureHidden(form, 'contact[utm_medium]', context.utm_medium);
      ensureHidden(form, 'contact[utm_campaign]', context.utm_campaign);
      ensureHidden(form, 'contact[utm_content]', context.utm_content);
      updateFormDisplay(form, context);
    });
  }

  function contextFromForm(form) {
    var fallback = contextFromLocation();

    function value(name, defaultValue) {
      var field = form.querySelector('input[name="' + name + '"]');
      return field && field.value ? field.value : defaultValue;
    }

    return {
      cta_id: value('contact[cta_id]', fallback.cta_id),
      route_id: value('contact[route_id]', fallback.route_id),
      route_version: value('contact[route_version]', fallback.route_version),
      intent: value('contact[intent]', fallback.intent),
      source_path: value('contact[source_path]', fallback.source_path),
      utm_source: value('contact[utm_source]', fallback.utm_source),
      utm_medium: value('contact[utm_medium]', fallback.utm_medium),
      utm_campaign: value('contact[utm_campaign]', fallback.utm_campaign),
      utm_content: value('contact[utm_content]', fallback.utm_content)
    };
  }

  function contextFromLocation() {
    var params = new URLSearchParams(window.location.search);
    var isInstagramProfile = params.get('utm_source') === 'instagram' &&
      params.get('utm_campaign') === 'instagram_business_profile' &&
      params.get('utm_content') === 'bio_link';
    var defaultCtaId = path === '/' && isInstagramProfile ? 'instagram-profile-bio-link' :
      (path === '/' ? 'homepage-site-survey-form' :
        (path === '/pages/contact-us' && params.get('utm_source') === 'instagram' ? 'instagram-profile-bio-link' : 'contact-site-survey-form'));
    return {
      cta_id: params.get('cta_id') || defaultCtaId,
      route_id: params.get('route_id') || routeId,
      route_version: params.get('route_version') || ROUTE_VERSION,
      intent: params.get('intent') || 'site-survey-request',
      source_path: params.get('source_path') || path,
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_content: params.get('utm_content') || ''
    };
  }

  function storageRead(key) {
    try {
      var value = window.sessionStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  }

  function storageWrite(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      return false;
    }
  }

  function createEventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return 'lynktr-' + window.crypto.randomUUID();
    }

    return 'lynktr-' + Date.now() + '-' + Math.random().toString(36).slice(2, 12);
  }

  function rememberPendingFormSubmission(context) {
    storageWrite(PENDING_FORM_KEY, {
      event_id: createEventId(),
      cta_id: context.cta_id,
      route_id: context.route_id,
      route_version: context.route_version,
      intent: context.intent,
      source_path: context.source_path,
      created_at: new Date().toISOString()
    });
  }

  function formSubmitSuccessFromLocation() {
    var params = new URLSearchParams(window.location.search);
    if ((path !== '/pages/contact-us' && path !== '/') || params.get('contact_posted') !== 'true') return null;

    var pending = storageRead(PENDING_FORM_KEY);
    var fallback = contextFromLocation();

    return {
      event_id: pending && pending.event_id ? pending.event_id : createEventId(),
      event_name: 'form_submit_success',
      cta_id: pending && pending.cta_id ? pending.cta_id : fallback.cta_id,
      route_id: pending && pending.route_id ? pending.route_id : fallback.route_id,
      route_version: pending && pending.route_version ? pending.route_version : fallback.route_version,
      intent: pending && pending.intent ? pending.intent : fallback.intent,
      source_path: pending && pending.source_path ? pending.source_path : fallback.source_path,
      enquiry_status: 'received_unvalidated'
    };
  }

  function privacyAllows(methodName) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy[methodName] !== 'function') return false;

    try {
      return privacy[methodName]() === true;
    } catch (error) {
      return false;
    }
  }

  function loadPrivacyApi(callback) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      callback();
      return;
    }

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      callback();
      return;
    }

    window.Shopify.loadFeatures([
      { name: 'consent-tracking-api', version: '0.1' }
    ], function () {
      callback();
    });
  }

  function publishFormSubmitSuccess(payload) {
    var deliveryKey = DELIVERY_KEY_PREFIX + payload.event_id;
    var delivery = storageRead(deliveryKey) || {};
    var analyticsAllowed = privacyAllows('analyticsProcessingAllowed');
    var marketingAllowed = privacyAllows('marketingAllowed');
    var saleAllowed = privacyAllows('saleOfDataAllowed');

    if (!delivery.dom) {
      document.dispatchEvent(new CustomEvent('lynktr:form-submit-success', {
        detail: payload
      }));
      delivery.dom = true;
    }

    if (analyticsAllowed && !delivery.shopify && window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try {
        var publishResult = window.Shopify.analytics.publish(FORM_SUCCESS_EVENT_NAME, payload);
        delivery.shopify = true;

        if (publishResult && typeof publishResult.then === 'function') {
          publishResult.then(function (published) {
            delivery.shopify = published !== false;
            storageWrite(deliveryKey, delivery);
          }).catch(function () {
              delivery.shopify = false;
              storageWrite(deliveryKey, delivery);
            });
        } else if (publishResult === false) {
          delivery.shopify = false;
        }
      } catch (error) {}
    }

    if (analyticsAllowed && !delivery.ga4) {
      var ga4Payload = {
        event_id: payload.event_id,
        cta_id: payload.cta_id,
        route_id: payload.route_id,
        route_version: payload.route_version,
        intent: payload.intent,
        source_path: payload.source_path,
        enquiry_status: payload.enquiry_status
      };

      if (typeof window.gtag === 'function') {
        window.gtag('event', payload.event_name, ga4Payload);
        delivery.ga4 = true;
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: payload.event_name }, ga4Payload));
        delivery.ga4 = 'queued';
      }
    }

    if (marketingAllowed && saleAllowed && !delivery.meta && typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', {
        content_name: payload.event_name,
        cta_id: payload.cta_id,
        route_id: payload.route_id,
        route_version: payload.route_version,
        intent: payload.intent,
        source_path: payload.source_path,
        enquiry_status: payload.enquiry_status
      }, {
        eventID: payload.event_id
      });
      delivery.meta = true;
    }

    delivery.analytics_allowed = analyticsAllowed;
    delivery.marketing_allowed = marketingAllowed;
    delivery.sale_allowed = saleAllowed;
    storageWrite(deliveryKey, delivery);

    document.documentElement.setAttribute('data-lynktr-form-submit-success', payload.event_id);
    document.documentElement.setAttribute('data-lynktr-form-submit-success-delivery', [
      delivery.shopify ? 'shopify' : '',
      delivery.ga4 === true ? 'ga4' : (delivery.ga4 === 'queued' ? 'ga4-queued' : ''),
      delivery.meta ? 'meta' : ''
    ].filter(Boolean).join(','));
  }

  function trackFormSubmitSuccess() {
    var payload = formSubmitSuccessFromLocation();
    if (!payload) return;

    loadPrivacyApi(function () {
      publishFormSubmitSuccess(payload);
      window.setTimeout(function () { publishFormSubmitSuccess(payload); }, 1500);
      window.setTimeout(function () { publishFormSubmitSuccess(payload); }, 5000);
    });

    document.addEventListener('visitorConsentCollected', function () {
      publishFormSubmitSuccess(payload);
    });
  }

  normaliseContactSurveyLabels();

  function annotate() {
    var seen = {};

    document.querySelectorAll(trackedSelector).forEach(function (element) {
      var place = placement(element);
      var intent = intentFor(element);
      var label = slug(element.textContent || element.getAttribute('aria-label'));
      var base = place + '-' + intent + '-' + label;
      seen[base] = (seen[base] || 0) + 1;
      var ctaId = base + (seen[base] > 1 ? '-' + seen[base] : '');
      var context = contextFor(element, ctaId);

      element.setAttribute('data-cta-id', context.cta_id);
      element.setAttribute('data-route-id', context.route_id);
      element.setAttribute('data-route-version', context.route_version);
      element.setAttribute('data-intent', context.intent);
      element.setAttribute('data-source-path', context.source_path);

      var href = element.getAttribute('href') || '';
      if (href.indexOf('/pages/contact-us') !== -1 || href.indexOf('/pages/request-a-site-survey') !== -1) {
        try {
          var destination = new URL(href, window.location.origin);
          destination.searchParams.set('route_id', context.route_id);
          destination.searchParams.set('route_version', context.route_version);
          destination.searchParams.set('intent', context.intent);
          destination.searchParams.set('cta_id', context.cta_id);
          destination.searchParams.set('source_path', context.source_path);
          element.setAttribute('href', destination.pathname + destination.search + destination.hash);
        } catch (error) {}
      }
    });
  }

  function attributionContext(element) {
    var locationContext = contextFromLocation();
    return {
      cta_id: element.getAttribute('data-cta-id') || '',
      route_id: element.getAttribute('data-route-id') || routeId,
      route_version: element.getAttribute('data-route-version') || ROUTE_VERSION,
      intent: element.getAttribute('data-intent') || 'site-survey-request',
      source_path: element.getAttribute('data-source-path') || path,
      utm_source: locationContext.utm_source,
      utm_medium: locationContext.utm_medium,
      utm_campaign: locationContext.utm_campaign,
      utm_content: locationContext.utm_content
    };
  }

  function bindAttribution() {
    document.addEventListener('click', function (event) {
      var element = event.target.closest(trackedSelector);
      if (!element) return;

      if (element.matches('button[type="submit"]')) return;

      var context = attributionContext(element);
      applyContextToForms(context);

      document.dispatchEvent(new CustomEvent('lynktr:cta-attribution', {
        detail: context
      }));
    }, true);

    surveyForms().forEach(function (form) {
      form.addEventListener('submit', function () {
        var context = contextFromForm(form);
        applyContextToForms(context);
        rememberPendingFormSubmission(context);
      }, true);
    });
  }

  function init() {
    annotate();
    applyContextToForms(contextFromLocation());
    bindAttribution();
    trackFormSubmitSuccess();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

